import IEventSubscription from './IEventSubscription';

type Handler<T> = (arg: T) => any;

export default class EventHandler<T> {
  private listeners: Handler<T>[] = [];
  public readonly source: EventHandlerSource<T>;
  constructor() {
    this.source = new EventHandlerSource(this);
  }
  public onChange: (mode: string, size: number) => any;

  get listenerCount() {
    return this.listeners.length;
  }
  add = (action: Handler<T>) => {
    this.listeners.push(action);
    this.invokeOnChange('add');
  };
  remove = (action: Handler<T>) => {
    this.listeners.remove(action);
    this.invokeOnChange('remove');
  };
  private invokeOnChange = (mode: string) => {
    if (this.onChange) {
      this.onChange(mode, this.listeners.length);
    }
  };
  clear() {
    this.listeners = [];
  }
  invoke = (arg: T) => {
    setTimeout(() => {
      this.listeners.forEach((action) => {
        try {
          action(arg);
        } catch {
          //
        }
      });
    }, 1);
  };
  invokeSync = (arg: T) => {
    this.listeners.forEach((action) => {
      try {
        action(arg);
      } catch {
        //
      }
    });
  };
}

class EventHandlerSource<T> {
  constructor(private readonly handler: EventHandler<T>) {}
  add = (callback: (t: T) => any): IEventSubscription => {
    this.handler.add(callback);
    return {
      dispose: () => this.remove(callback),
    };
  };
  private remove = (callback: (t: T) => any) => {
    this.handler.remove(callback);
  };
}
